export const COMMENT_EMPTY_PLACEHOLDER = '-';
export const COMMENT_PREVIEW_LIMIT = 40;
export const MANAGER_COMMENT_MAX_LENGTH = 255;

export const CLIENT_COMMENT_LABELS = {
  details: 'Детальніше',
  dialogTitle: 'Коментар',
  close: 'Закрити',
  closeAria: 'Закрити',
} as const;

export const MANAGER_COMMENT_LABELS = {
  add: 'Додати',
  editTooltip: 'Редагувати коментар',
  viewTooltip: 'Переглянути коментар',
  readOnlyTitle: 'Перегляд коментаря',
  dialogTitle: 'Коментар',
  placeholder: 'Введіть ваш коментар',
  cancel: 'Скасувати',
  save: 'Зберегти',
  saving: 'Збереження...',
  close: 'Закрити',
  closeAria: 'Закрити',
  saveError: 'Не вдалося зберегти коментар:',
} as const;
